import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import axios from "axios";
import { AppRoutes } from "./AppRoutes";
import AuthInit from "./AuthInit";
import PermissionProvider from "./PermissionProvider";
import { ThemeProvider } from "../theme/ThemeProvider";
import { useEffect } from "react";
import { loadContentStyles, loadThemeStyles } from "../assets";

function App({ store, persistor }) {
	// Request interceptors
	axios.interceptors.request.use(
		(config) => {
			if (!config.headers.Authorization) {
				const state = store.getState();

				if (state.auth.token) {
					config.headers.Authorization = `Bearer ${state.auth.token}`;
				}
			}

			return config;
		},
		(err) => Promise.reject(err)
	);

	useEffect(() => {
		loadThemeStyles();
		loadContentStyles();
	}, []);

	return (
		<BrowserRouter>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<AuthInit>
						<PermissionProvider>
							<ThemeProvider>
								<AppRoutes />
							</ThemeProvider>
						</PermissionProvider>
					</AuthInit>
				</PersistGate>
			</Provider>
		</BrowserRouter>
	);
}

export default App;
